import { render, staticRenderFns } from "./hzgl.vue?vue&type=template&id=2f8c4487&scoped=true&"
import script from "./hzgl.vue?vue&type=script&lang=js&"
export * from "./hzgl.vue?vue&type=script&lang=js&"
import style0 from "./hzgl.vue?vue&type=style&index=0&id=2f8c4487&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c4487",
  null
  
)

export default component.exports